var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.exhibitions,"item-text":("title." + _vm.language),"label":_vm.$t('exhibitionSelector.select'),"loading":_vm.loading,"return-object":true},on:{"change":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }